import * as R from '../../../routes';
import { getAdminRouteForNavigation } from '../../../routes-pairs';
import { getAngularServiceWeak } from '../AngularService';
import { getCurrentUser } from '../CurrentUser';
import { isFeatureEnabled } from '../Features';
import { redirect } from '../Router';

function redirectToApp(url: string, params?: { [key: string]: string }, forceReload?: boolean) {
    redirect(`/app${url}`, params, forceReload);
}

export function goToReviewCycleOverview(cycleId: string): void {
    getAngularServiceWeak('ReviewCycleLookupService')?.reset();
    redirectToApp(R.ADMIN_REVIEWS_WITH_CYCLE, { cycleId });
}

export function goToReviewCycleManagement(): void {
    redirectToApp(R.ADMIN_REVIEWS_SELECT_CYCLE);
}

export function goToFeedbackCycleOverview(cycleId: string): void {
    getAngularServiceWeak('FeedbackCycleLookupService')?.reset();
    redirectToApp(R.ADMIN_FEEDBACK_WITH_CYCLE, { cycleId });
}

export function goToFeedbackCycleManagement(): void {
    redirectToApp(R.ADMIN_FEEDBACK_SELECT_CYCLE);
}

export function goToObjectiveCycleOverview(cycleId: string): void {
    getAngularServiceWeak('ObjectiveCycleLookupService')?.reset();
    redirectToApp(getAdminRouteForNavigation(R.OBJECTIVES_COMPANY_CYCLE), { cycleId });
}

export function goToObjectiveCycleManagement(): void {
    redirectToApp(getAdminRouteForNavigation(R.OBJECTIVES_COMPANY_CYCLES));
}

export function goToFeedbackForYouPage(): void {
    redirectToApp(isFeatureEnabled('FEATURE_adminNavigationRefresh') ? R.FEEDBACK_USER_FOR_YOU : R.FEEDBACK_USER);
}

export function goToMeetingDedicatedPage(meetingId: string): void {
    redirectToApp(R.MEETING_DEDICATED, { meetingId });
}

export function goToMeetingPage(participantId: string, forceReload: boolean): void {
    redirectToApp(R.MEETING_PAGE, { userIds: `${getCurrentUser().id}${participantId}` }, forceReload);
}

export function goToMeetingOverviewPage(): void {
    redirectToApp(isFeatureEnabled('FEATURE_adminNavigationRefresh') ? R.MEETING_OVERVIEW_YOUR : R.MEETING_OVERVIEW);
}

export function goToDashboardPage() {
    redirectToApp(R.DASHBOARD);
}

export function goToOnboardingSurveyOriginStep() {
    redirectToApp(R.COMPANY_ONBOARDING_ORIGIN);
}

export function goToOnboardingSurveyInterestStep() {
    redirectToApp(R.COMPANY_ONBOARDING_INTEREST);
}

export function goToOnboardingSurveyHris() {
    redirectToApp(R.COMPANY_ONBOARDING_HRIS);
}

export function goToOnboardingSurveyDone() {
    redirectToApp(R.COMPANY_ONBOARDING_DONE);
}

export function goToCheckout() {
    redirectToApp(R.ADMIN_BILLING_CHECKOUT);
}
